<p-panel>
    <app-reactive-form-builder *ngIf="!loadingData && form" #builderRef [form]="form.formFields"
        [serverUrl]="form.env.serverUrl" [id]="getRegisterId().toString()"
        [request]="getType() === 1 ? tratamientosApi.tratamientosPUT : tratamientosApi.tratamientosPOST"
        [getRequest]="tratamientosApi.tratamientosGET" [previousData]="initialPreviousData"
        [dropdownLoadTrigger]="dropdownLoadTrigger" [dropdownsFinalized]="dropdownsFinalized"
        (formChanges)="formChanges($event[0], $event[1])" (goBack)="goBack()">
    </app-reactive-form-builder>
</p-panel>
